import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ConceptValues } from '@asambleas-models/concept-values.model';
import { GeneralService } from '@asambleas-services/general/general.service';
import { Concept } from '@asambleas-models/concept.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { Church } from '@asambleas-models/church.model';
import { map, startWith } from 'rxjs/operators';
import { ChurchService } from '@asambleas-services/church/church.service';
import { Minister } from '@asambleas-models/minister.model';
import { LoadService } from '@asambleas-components/loader/loader.service';
import { MinisterService } from '@asambleas-services/minister/minister.service';

@Component({
  selector: 'app-edit-minister',
  templateUrl: './edit-minister.component.html',
  styleUrls: ['./edit-minister.component.scss']
})
export class EditMinisterComponent implements OnInit {
  minister: Minister;

  ministerLevels: ConceptValues;
  ministerTypes: ConceptValues;
  allChurches: Church[] = [];
  filteredChurches: Observable<Church[]>;
  churchSelected: Church;

  form: FormGroup;

  myControl = new FormControl();

  constructor(private _dialogRef: MatDialogRef<EditMinisterComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private generalService: GeneralService,
    private churchService: ChurchService,
    private ministersService: MinisterService,
    private _loadService: LoadService) { }

  ngOnInit() {
    this.minister = this.data.minister;
    this.churchSelected = this.minister.church;

    console.log('MINISTRO', this.minister);

    this.ministerLevels = this.generalService.concepts[10]
    if (this.ministerLevels == null) {
      this.generalService.getConceptDataById(10).subscribe((data: Concept) => {
        this.ministerLevels = data.values
      })
    }

    this.ministerTypes = this.generalService.concepts[13]
    if (this.ministerTypes == null) {
      this.generalService.getConceptDataById(13).subscribe((data: Concept) => {
        this.ministerTypes = data.values
      })
    }

    this.churchService.getAllChurches()
      .subscribe((data: Church[]) => {
        this.allChurches = data;

        this.setChurchFilterOptions();
      })
  }

  setChurchFilterOptions() {
    this.filteredChurches = this.myControl.valueChanges.pipe(
      startWith(''),
      map(val => this.filterChurch(val))
    );
  }

  filterChurch(opt: any): Church[] {
    if (typeof (opt) == "string") {
      return this.allChurches.filter(option => option.name.toLowerCase().indexOf(opt.toLowerCase()) !== -1);
    } else if (typeof (opt) == "object") {
      return this.allChurches.filter(option => option.name.toLowerCase().indexOf(opt.name.toLowerCase()) !== -1);
    } else {
      return this.allChurches;
    }
  }

  displayFnChurch(church?: Church): string | undefined {
    return church ? church.name : undefined;
  }

  sendForm() {
    this.minister.church_id = this.churchSelected.id;

    let loader = this._loadService.createLoad()
    loader.open()

    this.ministersService.updateMinister(this.minister.id, this.minister)
      .subscribe((response) => {
        loader.close();

        this._dialogRef.close({ success: true });
      }, (error) => {
        loader.close();

        this._dialogRef.close({ success: false });
        console.log('Hubo un error');
      })
  }

  close() {
    this._dialogRef.close()
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/edit-minister/edit-minister.component.ts